import { createContext, useContext } from "react"

export const DetailPanelCollapseContext = createContext<(() => void) | null>(
  null,
)

export function useCollapseDetailPanel() {
  return useContext(DetailPanelCollapseContext)
}
